var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMinusCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/minus--1stroke copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.2468267,80.9326933 C88.8356267,80.9326933 89.3134933,81.41056 89.3134933,81.99936 C89.3134933,82.58816 88.8356267,83.0660267 88.2468267,83.0660267 L71.7582933,83.0660267 C71.16736,83.0660267 70.6916267,82.58816 70.6916267,81.99936 C70.6916267,81.41056 71.16736,80.9326933 71.7582933,80.9326933 L88.2468267,80.9326933 Z M91.3322667,89.9722667 C92.992,87.6170667 93.8666667,84.8608 93.8666667,82 C93.8666667,74.3541333 87.6458667,68.1333333 80,68.1333333 C72.3541333,68.1333333 66.1333333,74.3541333 66.1333333,82 C66.1333333,85.0272 67.0997333,87.8944 68.9237333,90.2944 C71.2874667,93.4816 74.8992,95.4869333 78.8352,95.8112 C79.7674667,95.9008 80.6656,95.8688 81.5381333,95.7749333 C85.4933333,95.3397333 89.0645333,93.2234667 91.3322667,89.9722667 Z M80,66 C88.8234667,66 96,73.1765333 96,82 C96,85.3045333 94.9909333,88.4853333 93.0773333,91.1968 C90.4618667,94.9514667 86.336,97.3941333 81.7706667,97.8954667 C81.1925333,97.9573333 80.5994667,98 80,98 C79.5498667,98 79.0997333,97.9786667 78.6474667,97.936 C74.112,97.5648 69.9413333,95.2458667 67.2170667,91.5765333 C65.1157333,88.8117333 64,85.4944 64,82 C64,73.1765333 71.1786667,66 80,66 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/minus--1stroke-copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/minus",
    transform: "translate(-64.000000, -66.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Fill-6",
    fill: "#2A2A3A",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/#2B2A3A",
    mask: "url(#mask-2)",
    fill: "#2B2A3A"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 158,
    height: 162
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinusCircle);
export default __webpack_public_path__ + "static/media/icon-minus-circle.4fc49dac8b9085e1e85c33c3afe9c536.svg";
export { ForwardRef as ReactComponent };